module.exports = __webpack_public_path__ + "img/V-R-135-unload-standup-base.1f9f6267.png";